import { TYPOGRAPHY_TYPE_TO_HTML_TAG } from './Text.constants';
export function isTypographyType(as) {
  return Object.keys(TYPOGRAPHY_TYPE_TO_HTML_TAG).includes(as);
}